(function(){
  function currentIndex(track){
    const w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }
  function scrollToIndex(track, idx){
    const w = track.clientWidth || 1;
    track.scrollTo({ left: idx * w, behavior: 'smooth' });
  }

  // 1) CLIQUES NAS SETAS (delegação global)
  document.addEventListener('click', (e)=>{
    const prevBtn = e.target.closest('[data-prev]');
    const nextBtn = e.target.closest('[data-next]');
    if (!prevBtn && !nextBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const media = (prevBtn || nextBtn).closest('.pi-media');
    if (!media) return;

    const track = media.querySelector('.pi-track');
    if (!track) return;

    const slides = track.querySelectorAll('.pi-slide');
    if (slides.length < 2) return;

    const i = currentIndex(track);
    const target = prevBtn ? (i - 1 + slides.length) % slides.length
                           : (i + 1) % slides.length;

    scrollToIndex(track, target);
  }, false);

  // 2) MOSTRAR/ESCONDER SETAS NO MOBILE (apenas visual)
  function updateArrows(media){
    const track = media.querySelector('.pi-track');
    if (!track) return;
    const i = currentIndex(track);
    if (i > 0) media.classList.add('show-arrows');
    else media.classList.remove('show-arrows');
  }
  function bind(media){
    const track = media.querySelector('.pi-track');
    if (!track) return;

    updateArrows(media);

    let raf = null;
    track.addEventListener('scroll', ()=>{
      if (raf) return;
      raf = requestAnimationFrame(()=>{ raf = null; updateArrows(media); });
    }, { passive: true });

    window.addEventListener('resize', ()=>updateArrows(media));
  }

  // inicializa existentes
  document.querySelectorAll('.pi-media').forEach(bind);
  // re-inicializa em loads dinâmicos
  document.addEventListener('shopify:section:load', (e)=>{
    e.target.querySelectorAll?.('.pi-media').forEach(bind);
  });
  document.addEventListener('product-list:updated', ()=>{
    document.querySelectorAll('.pi-media').forEach(bind);
  });
})();

// === Reconhece novos .pi-media inseridos dinamicamente e vincula neles ===
(function(){
  // função que marca e vincula apenas uma vez
  function safeBind(media) {
    if (!media || media.dataset.piBound === '1') return;
    // marca como vinculado para evitar duplo binding
    media.dataset.piBound = '1';

    // replica o "bind" que você já usa: attach scroll listener e updateArrows
    const track = media.querySelector('.pi-track');
    if (!track) return;

    // função local de update (mesma lógica já presente)
    function currentIndex(trackEl){
      const w = trackEl.clientWidth || 1;
      return Math.round(trackEl.scrollLeft / w);
    }
    function updateArrowsLocal(){
      const i = currentIndex(track);
      if (i > 0) media.classList.add('show-arrows');
      else media.classList.remove('show-arrows');
    }

    // inicializa
    updateArrowsLocal();

    // scroll listener com rAF
    let raf = null;
    track.addEventListener('scroll', ()=>{
      if (raf) return;
      raf = requestAnimationFrame(()=>{ raf = null; updateArrowsLocal(); });
    }, { passive: true });

    // resize
    window.addEventListener('resize', ()=>updateArrowsLocal());
  }

  // processa os que já existem (por segurança)
  document.querySelectorAll('.pi-media').forEach(safeBind);

  // observa o body por nós adicionados que contenham .pi-media
  const observer = new MutationObserver((mutations)=>{
    for (const m of mutations) {
      if (!m.addedNodes || m.addedNodes.length === 0) continue;
      m.addedNodes.forEach(node=>{
        // se o nó adicionado contiver vários .pi-media, vincula todos
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.pi-media')) {
          safeBind(node);
        } else {
          // procurar descendentes .pi-media
          node.querySelectorAll && node.querySelectorAll('.pi-media').forEach(safeBind);
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // opcional: expõe uma função global para forçar rebind manual (útil para debug)
  window.__pi_rebind_all = function(){
    document.querySelectorAll('.pi-media').forEach(media=>{
      // remove marcação e rebind
      delete media.dataset.piBound;
      safeBind(media);
    });
  };
})();
